<template>
    <div class="app-groups" v-show="visible" @click="hide">
      <transition
        enter-active-class="animated zoomIn"
        leave-active-class="animated zoomOut"
        @leave="leave"
      >
      <div class="app-groups-inner" v-show="innerVisible" @click.stop="function(){}">
        <Button type="text" @click="hide" style="float:right;margin:-10px -15px 0 0"><Icon type="close-round"></Icon></Button>
        <h6>{{title}}</h6>
        <div class="apps-icon-navs">
          <template v-for="(route,index) in data">
          <a href="javascript:void(0);" @click="$parent.routeTo(route)" v-if="route.visible" class="nav-link" :key="index">
            <Badge :count="countNumber(route.name)">
              <div class="nav-item">
                <svg class="icon" aria-hidden="true">
                  <use :xlink:href="'#'+route.icon"></use>
                </svg>
              </div>
            </Badge>
            <span class="nav-title">{{route.title}}</span>
          </a>
          </template>
      </div>
      </div>
      </transition>
      <!-- <Spin size="small" fix v-if="visible"></Spin> -->
    </div>
</template>

<script>

export default {
  name: 'AppGroups',
  props: {
    title: String,
    visible: {
      default: false
    },
    data: {
      type: Array
    },
    text: {
      default: '正在加载,请稍等...'
    }
  },
  data () {
    return {
      innerVisible: false
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.innerVisible = true
        this.$parent.isBlur = true
      } else {
        this.$parent.isBlur = false
        this.innerVisible = false
      }
    }
  },
  mounted () {
    // this.$router.push({'path': '/home'})
  },
  methods: {
    hide () {
      this.innerVisible = false
    },
    leave () {
      setTimeout(() => {
        this.$parent.groupsVisible = false
        // this.$emit('visible:update', false)
      }, 200)
    },
    isDisabled () {},
    countNumber (name) {
      let number = 0
      switch (name) {
        case 'leave':
          number = this.$store.state.badge.leave
          break
        case 'quit':
          number = this.$store.state.badge.quit
          break
      }
      return number
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .app-groups{
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba(255,255,255,.5);
    z-index: 8000;
    margin: auto;
    left: 0;
    top: 0;
  }
  .app-groups-inner{
    width: 320px;
    height: 320px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -140px;
    margin-top: -140px;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 0 20px rgba(0, 0, 0, .3);
    background: rgba(255, 255, 255, .8);
  }
  .app-groups .apps-icon-navs{padding:0 20px;height: 300px;}
  .app-groups .apps-icon-navs .nav-link{width: 50%;}
  .app-groups .apps-icon-navs .nav-item{
    width: 60px;
    height: 60px;
    margin-bottom: 5px;
  }
  .app-groups .apps-icon-navs .nav-title{
    width: 52px;
    padding: 1px 2px;
  }
  .app-groups .apps-icon-navs{position: static}
</style>
